import React from 'react'
import {ServerConfig} from 'config'

import PaginatedList from '../../components/PaginatedList/PaginatedList'


const ScrapRefundrates = () => {
  const non_editable_fields = [
    ["id", "ID"],
    ["uid", "UID"],
    //["created_ts", "Created"],
    ["last_changed_ts", "Changed"],
    //["assigned_to_tenant_ts", "Assigned Tenant"],
    ["assigned_to_tenant_employee_ts", "Assigned Tenant-Empl"],
    ["version", "Version"],
  ];

  const editable_fields = [
    ["tenant_employee_id", "Tenant Employee ID"],
    ["password", "Password"],
  ];

  return (
    <>
      <PaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/nfctoken/`}
        detail_get_url={`${ServerConfig.SERVER_URL}/nfctoken/detail/`}
        detail_put_url={`${ServerConfig.SERVER_URL}/nfctoken/`}

        column_names={["id", "tenant_employee_id"]}
        header_names={["ID", "Tenant Empl ID"]}

        optional_column_names={["uid"]}
        optional_header_names={["UID"]}

        editable_fields={editable_fields}
        non_editable_fields={non_editable_fields}

        //ledger_get_url = '/ledger/customer/'
        //show_machine_stats={true}
      />
    </>
  )
}

export default ScrapRefundrates
